import * as React from "react";

function SvgBigHamburger(props) {
  return <svg width={32} height={20} viewBox="0 0 32 20" fill="none" {...props}><rect x={0.5} y={0.5} width={31} height={1} rx={0.5} fill="currentColor" strokeLinecap="round" strokeLinejoin="round" /><rect x={0.5} y={9.5} width={31} height={1} rx={0.5} fill="currentColor" strokeLinecap="round" strokeLinejoin="round" /><rect x={0.5} y={18.5} width={31} height={1} rx={0.5} fill="currentColor" strokeLinecap="round" strokeLinejoin="round" /></svg>;
}

export default "//cdn.scentbird.com/assets/frontbird-site/images/big-hamburger_89a3e3.svg";
export { SvgBigHamburger as ReactComponent };